import { render, staticRenderFns } from "./MapiHistory.vue?vue&type=template&id=4cf63cb9&"
import script from "./MapiHistory.vue?vue&type=script&lang=js&"
export * from "./MapiHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports